import { get } from 'lodash/object';
import { fetchProgramCss } from "../api";
import { loadExternalCSS } from "./css";

const updateFavicon = href => {
  const documentHead = (document.head || document.getElementsByTagName('head')[0]);

  const currentFavicon = document.getElementById('program-favicon');
  const newFavicon = document.createElement('link');
  newFavicon.id = 'program-favicon';
  newFavicon.rel = 'shortcut icon';
  newFavicon.href = href;

  if (currentFavicon) {
    documentHead.removeChild(currentFavicon);
  }
  if(href){
    documentHead.appendChild(newFavicon);
  }
};

const updateDocumentTitle = title => {
  window.document.title = title || '';
};

const loadProgramStyleSheets = async (stylesheets = []) => {
  if (stylesheets.length) {
    let styles = await Promise.all(stylesheets.map(styleSheet => fetchProgramCss(styleSheet)));
    styles = styles
      .map((style, idx) => ({...style, id: stylesheets[idx]}))
      .filter(response => response.status === 200);

    styles.forEach(stylesheet => loadExternalCSS(stylesheet.data, stylesheet.id));
    styles.forEach(sheet => console.log(sheet.id, sheet))
  }
};

export const loadProgramResources = programConfig => {
  // given a program config, load any specific favicon, title, or program-defined CSS styles
  const { favicon, title } = get(programConfig, 'document', {});
  const stylesheets = get(programConfig, 'stylesheets', []);

  updateFavicon(favicon);
  updateDocumentTitle(title);
  loadProgramStyleSheets(stylesheets);
};
